<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choosetag(item.id)">
            <span style="cursor:pointer"  [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div *ngIf="now == '0'">
        <section class="example-section" style="margin:0 0 10px 0">
            <div style="margin-bottom: 10px;">
                <input type="text" [(ngModel)]="search_model" (keyup.enter)="init_list()" class="form-control" style="width: 240px;display:inline-block;margin-right: 15px;" placeholder="請輸入想搜尋的人名後點enter">
                <label style="margin-right: 10px;"> 
                    <input type="checkbox" [checked]="searchaccuse" (change)="searchaccuse=!searchaccuse"/>只搜尋被投訴者
                </label>
            </div>
            
            <span  style="margin-right: 10px;color:#bbb">處理狀態條件包含:</span>
            <label style="margin-right: 10px;"> 
                <input type="checkbox" [checked]="allstatus" (change)="allstatus=!allstatus;all()"/>全選
            </label>
            <label *ngFor="let item of status_option; let i = index" style="margin-right: 10px;">
                <input type="checkbox" [checked]="check_it(item.id)" (change)="choose(item.id)"/>{{item.name}}
            </label>
        </section>

        <app-date [time]="time" [type]="true" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
        <a [href]="urltoken" *ngIf="urltoken.length>0 && data.length>0" style="margin:10px;font-size: 20px;margin-right: 3%;"  target="_blank">
            <i class="fa fa-download"></i>
        </a>

        投訴原因 : 
        <select class="form-control" 
        style="width: 160px;display: inline-block;"
        [(ngModel)]="reason"
        (change)="init_list()"
        >
        <option  value="-2">全部</option>
        <option *ngFor="let item of reason_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <table style="margin-top: 10px;"  class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
              <tr class="table-primary" style="font-size:18px;">
                <th style="width:5%">投訴類型</th>
                <th style="width:5%">投訴原因</th>
                <th style="width:5%">價格</th>
                <th style="width:10%">佐證圖片</th>
                <th style="width:5%">處理狀態</th>
                <th style="width:5%">投訴者</th>
                <th style="width:10%">被投訴者</th>
                <th style="width:5%">投訴標的</th>
                <th style="width:5%">投訴時間</th>
                <th style="width:5%">操作</th>
                <th style="width:5%">最後操作人</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.title}}</td>
                    <td>{{item.reasons}}</td>
                    <td>{{item.f_diamond}}</td>

                    <td>
                        <img loading="lazy" *ngIf="item.pic.length>0" style="height:100px" [src]="item.pic">
                        <span *ngIf="item.pic.length==0">無附圖</span>
                    </td>
                
                    <td>{{item.status_name}}</td>
                    <td>
                        <app-userandactive  [post]="item" [active]="1"></app-userandactive>
                    </td>
                    <td>
                        <app-userandactive  [post]="item" [active]="2"></app-userandactive>
                    
                        <br>({{item.total_diamond|number}})
                    </td>
                    <td *ngIf="item.furl.length==0"></td>
                    <td *ngIf="item.furl.length!=0"><a target="_blank" [href]="item.furl">連結</a></td>
                    <td>{{item.create_dt}}</td>
                    <td>
                        <button (click)="edit_data=item;edit_data.result=-1"  class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-xl">處理</button>
                    </td>    
                    <td>{{item.emp_name=='系統'?'-':item.emp_name}}</td>
                </tr> 
            </tbody>
        </table>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
        <div *ngIf="data.length==0">無資料</div>
    </div>
    <div *ngIf="now == '1'">
        <input type="text" [(ngModel)]="searchcount_model" (keyup.enter)="user_count()" class="form-control" style="width: 240px;display:inline-block;margin-right: 15px;" placeholder="請輸入想搜尋的人名後點enter">
        <select class="form-control" style="width: 200px;display: inline-block;" [(ngModel)]="tool_obj.gender" (change)="user_count()">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select *ngIf="tool_obj.gender=='2' && v_list.length > 0" class="form-control" style="width: 160px;margin-left: 10px;display: inline-block;" [(ngModel)]="tool_obj.vid" (change)="user_count()">
            <option *ngFor="let item of v_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <app-date [time]="time" [type]="true" [timeset]="timeset" (rangeSelected)="handleRangeSelectedacc($event)"></app-date>
        <h5 style="text-align: center;margin: 10px;">被檢舉加總次數:{{appearance_count}}</h5>
        <div *ngIf="data.length > 0 && isDesktop == true" style="display:flex">
            <app-table [type]="2" [title]="title" [data]="data"  [content]="content" (link) = "handleClick($event)" (sortdata)="handlesortdata($event)"></app-table>
            <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 30%;margin:10px"></highcharts-chart>
            <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions2" style="display: block;width: 30%;margin:10px"></highcharts-chart>
        </div>

        <div *ngIf="data.length > 0  && isDesktop == false">
            <app-table [type]="2" [title]="title" [data]="data"  [content]="content" (link) = "handleClick($event)" (sortdata)="handlesortdata($event)"></app-table>
            <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 100%;margin:10px"></highcharts-chart>
            <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions2" style="display: block;width: 100%;margin:10px"></highcharts-chart>
        </div>


        <div *ngIf="data.length == 0"  class="no-data-container">
            無資料
        </div>

        <ng-template #yourModalContent let-modal>
            <div class="modal-header">
                <h4 class="modal-title">檢舉列表</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-table [type]="2" [title]="modeltitle" [data]="accusedata"  [content]="modelcontent"></app-table>
            </div>
            <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation> 
        </ng-template>
      
        <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation> 
    </div>
</div>

  <div 
*ngIf="edit_data"
class="modal fade bd-example-modal-xl" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"

 >
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title">審核</h4>
          <button type="button" id="close" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body"> 
        <div class="subtitle">投宿標的:</div>
        <div class="subitem">
          <a target="_blank" [href]="edit_data.furl">>連結</a>
        </div>
        <div class="subtitle">投訴類型:</div>
        <span class="">{{edit_data.reasons}}</span>
        <div class="subtitle">佐證圖片:</div>
        <div class="">
          <img loading="lazy" *ngIf="edit_data.pic && edit_data.pic.length>0" style="height:100px" [src]="edit_data.pic">
          <span *ngIf="edit_data.pic && edit_data.pic.length==0">無附圖</span>

        </div>

        <div class="subtitle">投訴內容:</div>
        <div class="accuse_content">{{edit_data.des}}</div>
        <div class="subtitle">回復檢舉者訊息:</div>
        <div class="subitem">
          <textarea style="min-height: 120px;" placeholder="請輸入內容"  [(ngModel)]="edit_data.judgment" class="form-control"></textarea>
          <span class="tips">一旦有打字並點選確認,無論處理動作選什麼都會將訊息發給檢舉者</span>
        </div>


        <div class="subtitle">通知被檢舉者訊息:</div>
        <div>
          <button 
          *ngFor="let subitem of accuse_template; let i = index"
          class="btn btn-primary"
          style="margin-left:3px"
          (click)="edit_data.notice_text=subitem.content"
          >
            {{subitem.name}}
          </button>

        </div>
        <div class="subitem">
          <textarea style="min-height: 120px;" placeholder="請輸入內容"  [(ngModel)]="edit_data.notice_text" class="form-control"></textarea>
          <span class="tips">一旦有打字並點選確認,無論處理動作選什麼都會將訊息發給被檢舉者</span>
          <div class="tips" *ngIf="edit_data.report_item_id*1==2">若無打字但動作為下架動態仍會發送預設訊息給被檢舉人</div>
        </div>


        <div class="subtitle">選擇處理動作:</div>
        <div>
            <button class="btn" [class]="edit_data.result*1==0?'btn-danger':'btn-secondary'" (click)="edit_data.result=0" style="margin: 5px;">無違規嫌疑</button>
            <button class="btn" [class]="edit_data.result*1==1?'btn-danger':'btn-secondary'"  (click)="edit_data.result=1" style="margin: 5px;" *ngIf="edit_data.report_item_id*1!=2">警告使用者</button>
                        
            <button class="btn btn-primary" [class]="edit_data.result*1==1?'btn-danger':'btn-secondary'" (click)="edit_data.result=1" *ngIf="edit_data.report_item_id*1===2" style="margin: 5px;">下架動態並警告上傳者</button>
            <button *ngIf="edit_data.report_item_id*1===2 && edit_data.f_diamond*1>0" class="btn btn-primary" [class]="edit_data.result*1==2?'btn-danger':'btn-secondary'" (click)="edit_data.result=2"  style="margin: 5px;">下架動態並警告上傳者且退款</button>
           
        </div>

        <div *ngIf="edit_data.result*1==1">
            <div class="subtitle">是否停權:</div>
            <div>
                <button class="btn" [class]="edit_data.accresult*1==1?'btn-danger':'btn-secondary'"  (click)="edit_data.accresult=1" style="margin: 5px;">是</button>           
                <button class="btn" [class]="edit_data.accresult*1==0?'btn-danger':'btn-secondary'" (click)="edit_data.accresult=0" style="margin: 5px;">否</button>
            </div>
        </div>
      </div>

      <div class="modal-footer">
            <app-check-permissions [data]="'Kus1'">
                <button type="button"  (click)="save()"  class="btn btn-primary" >確認</button>
            </app-check-permissions>
            <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
      </div>
      </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>